import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {
	/**
	 * 策略列表
	 * @param {page} 第几页
	 * @param {pageSize} 每页数量
	**/
	strategyList( params={} ) {
		return request({
	    url: baseUrl + '/device/Strategy',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 策略编辑
	**/
	strategyEdit(id,data){
		return request({
			url: baseUrl + '/device/Strategy/'+id,
			method:'PUT',
			data
		})
	},

	/**
	 * 策略添加
	**/
	strategyAdd(data){
		return request({
			url: baseUrl + '/device/Strategy',
			method:'POST',
			data
		})
	},

	/**
	 * 策略删除
	**/
	strategyDel(id){
		return request({
			url: baseUrl + '/device/Strategy/'+id,
			method:'DELETE'
		})
	},

	/**
	 * 策略分配-分配或者取消策略
	 * @param {type} 0未分配1已分配
	 * @param {lamp_ids} 1,2,3 所选设备
	 * @param {stg_id} 策略ID
	**/
	allotFen(data){
		return request({
			url: baseUrl + '/device/StrategyFen',
			method:'POST',
			data
		})
	},

	/**
	 * Lora空开开关闸
	**/
	airOpenControl(id,data){
		return request({
			url: baseUrl + '/device/setStrategySte/'+id,
			method:'POST',
			data
		})
	},

	/**
	 * 获取经纬度策略
	 * @param {id} 策略ID
	**/
	getStrategyInfo(id) {
		return request({
	    url: baseUrl + '/device/getStrategyInfo/'+id,
	    method: 'GET'
	  })
	},

	/**
	 * 集中控制器策略列表
	 * @param {page} 第几页
	 * @param {pageSize} 每页数量 
	**/
	foucusStrategyList( params={} ) {
		return request({
	    url: baseUrl + '/concentrator/Strategy',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 集中控制器策略编辑
	**/
	foucusStrategyEdit(id,data){
		return request({
			url: baseUrl + '/concentrator/Strategy/'+id,
			method:'PUT',
			data
		})
	},

	/**
	 * 集中控制器策略添加
	**/
	foucusStrategyAdd(data){
		return request({
			url: baseUrl + '/concentrator/Strategy',
			method:'POST',
			data
		})
	},

	/**
	 * 集中控制器策略删除
	**/
	foucusStrategyDel(id){
		return request({
			url: baseUrl + '/concentrator/Strategy/'+id,
			method:'DELETE'
		})
	},

	/**
	 * 获取已分配策略的列表
	 * @param {id} 策略id
	 * @param {page} 第几页
	 * @param {pageSize} 每页数量 
	**/
	foucusHaveStrategy( id, params={} ) {
		return request({
	    url: baseUrl + '/concentrator/StrategyList/'+id,
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 集中控制器策略分配-分配或者取消策略
	 * @param {type} 0未分配1已分配
	 * @param {lamp_ids} 1,2,3 所选设备
	 * @param {stg_id} 策略ID
	**/
	foucusAllotFen(data){
		return request({
			url: baseUrl + '/concentrator/StrategyFen',
			method:'POST',
			data
		})
	}
}